import { colors } from '../base/colors'

export const textField = {
  styleOverrides: {
    root: {
      fontFamily: 'Montserrat, sans-serif',
      '& .MuiInput-underline:after': {
        borderBottomColor: colors.info.main // Border color when focused
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor: colors.white.main, // Input background color
        '& fieldset': {
          borderColor: colors.primary.light, // Border color
          borderRadius: '0' // Border color
        },
        '&:hover fieldset': {
          borderColor: colors.info.main // Border color on hover
        },
        '&.Mui-focused fieldset': {
          borderColor: colors.info.main, // Border color when focused
          borderWidth: '1px' // Border width when focused
        },
        '&.Mui-error fieldset': {
          borderColor: colors.error.main // Border color when error
        }
      },
      '& .MuiOutlinedInput-root.Mui-disabled': {
        '& fieldset': {
          borderColor: colors.primary.light // Border color when disabled
        },
        '&:hover fieldset': {
          borderColor: colors.primary.light // Border color when disabled
        }
      },
      '& .MuiInputBase-input': {
        backgroundColor: colors.white.main, // Input background color
        '&:-webkit-autofill': {
          WebkitBoxShadow: `0 0 0 100px ${colors.white.main} inset`,
          WebkitTextFillColor: colors.text.primary
        }
      },
      '& .MuiFormHelperText-root': {
        color: colors.primary.main // Helper text color
      },
      '& input': {
        padding: '8px 12px',
        backgroundColor: colors.white.main
      },
      '& input[type=number]': {
        MozAppearance: 'textfield'
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      }
    }
  }
}
